const Footer = () => {
  return (
      <section id="footer" className="flex flex-row items-center w-full justify-center h-full bg-[#FFFFFF]">
          <div className="flex flex-col mq450:flex-col max-w-[1280px] w-full justify-between px-10 pt-[80px] pb-[56px] mq450:px-4 mq450:py-8 gap-[56px] mq450:gap-[40px]">
          <div id="top" className="flex flex-row mq450:flex-col w-full justify-between items-start mq450:gap-[32px]">
          <div id="left" className="flex flex-col gap-[56px] w-full items-start justify-start mq450:flex-col mq450:items-start mq450:gap-[40px]">
            <img
              src="/logo-footer.svg"
              className="h-[28px]"
            />
                        <div id="column1" className="flex flex-col gap-[24px] text-[16px] w-full text-[#362F5B] font-sofia-light tracking-[0.05em] leading-[140%] mq450:order-2">
            <div className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">EVERA Sp. z o.o.</div>
            <div className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">Grzybowska 80/82 / 700</div>
            <div className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">Warszawa, Polska</div>
            <div className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">NIP: 5272962715</div>
            </div>
          </div>
          <div id="line" className="hidden mq450:flex w-full h-[1px] bg-[#362F5B]"></div>
          <div id="right" className="flex flex-row mq450:justify-start gap-[80px] w-full items-start justify-end mq450:gap-[40px]">
            <div id="column1" className="flex flex-col gap-[24px] text-[16px] text-[#362F5B] font-sofia-light tracking-[0.05em] leading-[140%] mq450:order-2">
            <div className="text-[18px] font-silka-semibold font-[600] text-[#362F5B]">Produkty</div>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">MoonEase™</a>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">NightBloom™</a>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">LeafTrim™</a>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">BrightMind™</a>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">GlowLeaf™</a>
            <a href="#suple" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">ZenBlossom™</a>
            </div>
            <div id="column2" className="flex flex-col gap-[24px] text-[16px] text-[#362F5B] font-sofia-light tracking-[0.05em] leading-[140%] mq450:order-2">
            <div className="text-[18px] font-silka-semibold font-[600] text-[#362F5B]">Obserwuj nas</div>
            <div className="flex flex-row gap-[8px] items-center">
              <img src="/fb.svg" className="w-[24px]" />
            <a href="#facebook" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">Facebook</a>
            </div>
            <div className="flex flex-row gap-[8px] items-center">
              <img src="/ig.svg" className="w-[24px]" />
            <a href="#instagram" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B] no-underline visited:text-[unset]">Instagram</a>
            </div>
            </div>
          </div>
          </div>
          <div id="bottom" className="flex flex-col gap-[32px]">
          <div id="line" className="w-full h-[1px] bg-[#362F5B]"></div>
          <div id="text-bottom" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B]">© 2025 Evera. All rights reserved.</div>
          </div>
          </div>
      </section>
  );
};

export default Footer;
